import React, { Fragment } from 'react'
import { Button, Modal, ModalBody, FormFeedback, Col, Form, Input, CardBody, Media, Row } from 'reactstrap';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Dialog } from 'primereact/dialog';







export const ModalAutorizationInvoices = (props) => {

    const {
        modalAutorization, toggleModalAutorization, saveInvoices, handleSelecUser, handleSelectPassword, validatePassword, loadingServices, username


    } = props;




    return (

        <Dialog
            visible={modalAutorization}
            onHide={toggleModalAutorization}
            closable={true}
            maskClassName="custom-total-mask"
            headerStyle={{
                backgroundColor: '#0f172a',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0f172a', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            modal
            appendTo="self"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-file-text-o"></i>                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Pendientes a facturar
                            </div>


                        </div>

                    </div>
                </div>
            }


            className={`Global-dialog Global-dialog Global-blue Global-small-v `
            }
            draggable={false}
            footer={
                < div className="d-flex justify-content-end gap-2" >
                    <Button
                        disabled={loadingServices}
                        color="secondary"
                        type="button"
                        onClick={validatePassword}
                    >
                        {
                            loadingServices ? <>
                                <i className="fa fa-spinner fa-spin mr-1"></i>{"Actualizando..."}</>
                                :
                                "Autorizar"
                        }
                    </Button>
                    <Button
                        disabled={loadingServices}
                        color="danger"
                        type="button"
                        onClick={toggleModalAutorization}
                    >
                        Cancelar
                    </Button>

                </div >
            }
        >


            <Form className="theme-form pt-2" role="form">
                <Row className="align-items-stretch">
                    <Col md="3" className="d-flex justify-content-center align-items-center border-end">
                        <div className="side-lock-wrapper-2">
                            <img
                                src={require("../../assets/images/blog/password.svg")}
                                alt="user"
                                className="side-lock-icon"
                            />
                        </div>
                    </Col>

                    <Col md="9">
                        <Row className="g-3 mb-3 pt-2">
                            <Col md="6">
                                <label className="form-label-sm">Usuario</label>
                                <Input
                                    type="text"
                                    name="user_method"
                                    value={username}
                                    required={true}
                                    autoComplete="nope"
                                    onChange={(e) => handleSelecUser(e.target.value)}
                                    className="form-control form-control-sm input-air-primary"
                                    disabled={loadingServices ? true : false}
                                />
                                <FormFeedback>Escribe el usuario</FormFeedback>
                            </Col>

                            <Col md="6">
                                <label className="form-label-sm">Contraseña</label>
                                <Input
                                    type="password"
                                    name="user_password_method"
                                    required={true}
                                    autoComplete="nope"
                                    onChange={(e) => handleSelectPassword(e.target.value)}
                                    disabled={loadingServices ? true : false}



                                    className="form-control form-control-sm input-air-primary"
                                />
                                <FormFeedback>Escribe la contraseña</FormFeedback>
                            </Col>


                        </Row>
                    </Col>
                </Row>
            </Form>

        </Dialog >
        // <Modal isOpen={modalAutorization} toggle={toggleModalAutorization} backdrop='static' keyboard={false} centered={true}>
        //     <Form className="form theme-form" role="form">
        //         <ModalBody>   
        //         <CardBody className="socialprofile filter-cards-view p-l-0 p-b-0 p-r-0">

        //                 <>
        //                  <Media><Media className="img-100 img-fluid m-r-20 rounded-circle pt-3" src={require("../../assets/images/loginHelenLabs/User/UserWoman.svg")} alt="" />
        //                         <Media body>
        //                             <span className="d-block"><span><i className="icofont icofont-user"> </i><span className="px-2">{"Usuario"}
        //                             <Input
        //                             type="text"
        //                             name="user_method"
        //                             value={username}
        //                             required={true}
        //                             autoComplete="nope"
        //                             onChange={(e) => handleSelecUser(e.target.value)}
        //                             className="form-control form-control-sm input-air-primary"
        //                             disabled={loadingServices ? true : false}
        //                         />
        //                         <FormFeedback>Escribe el usuario</FormFeedback>
        //                            </span></span></span><span className="d-block"><span><i className="icofont icofont-key"></i><span className="px-2">{"Contraseña"}
        //                            <Input
        //                             type="password"
        //                             name="user_password_method"
        //                             required={true}
        //                             autoComplete="nope"
        //                             onChange={(e) => handleSelectPassword(e.target.value)}
        //                             disabled={loadingServices ? true : false}



        //                             className="form-control form-control-sm input-air-primary"
        //                         />
        //                         <FormFeedback>Escribe la contraseña</FormFeedback></span></span></span>
        //                         </Media>
        //                 </Media>
        //                 <Col sm="12" style={{textAlign : "right"}} className='p-l-0 p-r-0' > <br />
        //                     <div className="btngroup">
        //                         <Button disabled={loadingServices ? true : false}  color="danger text-center" type="button" onClick={toggleModalAutorization}>{"Cancelar"}</Button>
        //                         <Button disabled={loadingServices ? true : false} color="secondary text-center" type="button" onClick={validatePassword}  >{"Autorizar"}</Button>  
        //                     </div> 
        //                 </Col>
        //                 </>

        //         </CardBody>   
        //         </ModalBody>
        //     </Form>
        // </Modal>
    )
}
